/**
 * The FluidCloud mark.
 *
 * Byte-identical to FluidCloud's own `frontend/components/Logo.tsx` — the
 * ecosystem drop path with its blue gradient and the cloud glyph. Do not
 * redraw it: it is the same drop FluidDream's star sits in (see BrandMark),
 * which is what makes the two read as siblings rather than lookalikes.
 *
 * The gradient id is uniquified per instance so several marks on one page
 * cannot collide.
 */
import { useId } from 'react';

export interface FluidCloudMarkProps {
  /** Rendered box size in px. The mark is square. */
  size?: number;
}

export default function FluidCloudMark({ size = 19 }: FluidCloudMarkProps) {
  const id = useId();
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      aria-hidden="true"
      style={{ flex: 'none' }}
    >
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#56c4ff" />
          <stop offset="1" stopColor="#2f6bff" />
        </linearGradient>
      </defs>
      <path
        d="M32 5C32 5 13 27 13 41a19 19 0 1 0 38 0C51 27 32 5 32 5Z"
        fill={`url(#${id})`}
      />
      <g fill="#ffffff">
        <rect x="21" y="43.5" width="22" height="6" rx="3" />
        <circle cx="26.5" cy="42.5" r="5" />
        <circle cx="33" cy="40" r="6.5" />
        <circle cx="39" cy="43" r="4.6" />
      </g>
    </svg>
  );
}
